import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["searchInput", "locationButton", "locationStatus"];
  static values = {
    searchUrl: String,
    latitude: Number,
    longitude: Number,
    debounceMs: { type: Number, default: 300 },
  };

  connect() {
    this.searchTimeout = null;
  }

  disconnect() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
  }

  search() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(
      () => this.performSearch(),
      this.debounceMsValue,
    );
  }

  performSearch() {
    const query = this.searchInputTarget.value.trim();
    const url = new URL(this.searchUrlValue, window.location.origin);

    if (query.length > 0) {
      url.searchParams.set("q", query);
    }
    if (this.latitudeValue) {
      url.searchParams.set("latitude", this.latitudeValue);
    }
    if (this.longitudeValue) {
      url.searchParams.set("longitude", this.longitudeValue);
    }

    const frame = document.getElementById("nces-search-results");
    if (frame) {
      frame.src = url.toString();
    }
  }

  requestLocation() {
    if (!navigator.geolocation) {
      this.locationStatusTarget.textContent =
        "Geolocation is not supported by your browser.";
      return;
    }

    this.locationButtonTarget.disabled = true;
    this.locationStatusTarget.textContent = "Detecting location...";

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.latitudeValue = position.coords.latitude;
        this.longitudeValue = position.coords.longitude;
        this.locationStatusTarget.textContent = "Location detected!";
        this.locationButtonTarget.disabled = false;
        this.performSearch();
      },
      () => {
        this.locationStatusTarget.textContent =
          "Unable to detect location. Please search manually.";
        this.locationButtonTarget.disabled = false;
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  }
}
